import { SidebarTrigger } from '../../ui/sidebar';
import { BackgroundTasksWidget } from '../BackgroundTasksWidget';
import { BillingStatusPill } from '../Billing/BillingStatusPill';
import { Breadcrumbs } from './parts/Breadcrumbs';

const Header = () => {
  return (
    <header className="flex items-center justify-between gap-8 grid-in-header px-6 border-b border-border-bg-neutral h-(--main-header-height)">
      <div className="flex items-center gap-4">
        <div className="md:hidden">
          <SidebarTrigger className="justify-center md:justify-start" />
        </div>
        <Breadcrumbs />
      </div>
      <div className="flex items-center gap-2">
        <BackgroundTasksWidget />
        <BillingStatusPill />
      </div>
    </header>
  );
};

export default Header;
